/**
 * @generated SignedSource<<eaadb01e5d63539e2887a06cc4c36ffb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegionEditTabs_region$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RegionEditCities_region" | "RegionEditMain_region">;
  readonly " $fragmentType": "RegionEditTabs_region";
};
export type RegionEditTabs_region$key = {
  readonly " $data"?: RegionEditTabs_region$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegionEditTabs_region">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegionEditTabs_region",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RegionEditMain_region"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RegionEditCities_region"
    }
  ],
  "type": "Region",
  "abstractKey": null
};

(node as any).hash = "334d4c6fe83fceaefc285d9309d74805";

export default node;
